"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpClient = void 0;
const lodash_1 = __importDefault(require("lodash"));
const axios_1 = __importDefault(require("axios"));
const datadog_1 = __importDefault(require("@nerdwallet/datadog"));
const headers_1 = require("./headers");
function getNWA() {
    if (typeof window !== 'undefined') {
        return window.nwa;
    }
    return undefined;
}
/**
 * Creates a new `HttpClient` instance, which can be used to make calls to
 * nwapi services with the correct headers, etc.
 */
function createNewHttpClient(config) {
    // Timeout is specified in milliseconds.
    const DEFAULT_TIMEOUT = 5000;
    const { axios: axiosClient, nwa, xhrTimeout } = config;
    let kountSessionID;
    let referringClientID;
    function setKountSessionID(id) {
        kountSessionID = id;
    }
    function setReferringClientID(id) {
        referringClientID = id;
    }
    function setUserLoggedIn() {
        if (nwa) {
            nwa.setUserProp('gaUserAuthenticationState', 'logged_in');
        }
    }
    function setUserLoggedOut() {
        if (nwa) {
            nwa.setUserProp('gaUserAuthenticationState', 'logged_out');
        }
    }
    function fetch(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body, canonicalPath, followRedirect, method, serverRequest, url } = args;
            let { json } = args;
            const headers = args.headers || {};
            const cookies = args.cookies || {};
            const params = args.params || {};
            const timeout = args.timeout || xhrTimeout || DEFAULT_TIMEOUT;
            // We default to an empty object because nw_api requires a
            // valid json request body even if there are no inputs. Ideally SDKs would
            // explicitly pass in {} as input when this is needed, but too many
            // existing SDKs rely on the behavior here.
            // Explicitly check for `undefined` because SDKs may deliberately pass null
            // to opt out of this default.
            if (typeof body === 'undefined' && typeof json === 'undefined') {
                json = {};
            }
            // Basic request config.
            const axiosConfig = {
                method,
                url,
                params,
                // If we should follow any redirect, we follow Axios's default setting of 21.
                // Otherwise, follow none.
                maxRedirects: followRedirect ? 21 : 0,
                timeout,
                withCredentials: true,
                // `data` is the data to be sent as the request body
                // Only applicable for request methods 'PUT', 'POST', 'DELETE , and 'PATCH'
                data: json || body,
                transitional: {
                    silentJSONParsing: false, // will throw a SyntaxError if JSON parsing fails
                },
            };
            const context = {
                url,
                config,
                serverRequest,
                cookies,
                referringClientID,
                kountSessionID,
            };
            // Get all headers, including cookies
            const coreHeaders = yield (0, headers_1.getCoreHTTPHeaders)(context);
            axiosConfig.headers = Object.assign(Object.assign({}, headers), coreHeaders);
            const response = yield (!canonicalPath
                ? axiosClient(axiosConfig)
                : datadog_1.default.instrumented('node.outgoing_requests.http', {
                    tags: {
                        caller_client_id: config.clientID,
                        domain: url.replace(/^https?:\/\//, '').split('/')[0],
                        endpoint: canonicalPath.replace(/^https?:\/\//, ''),
                        method,
                    },
                }, () => axiosClient(axiosConfig)));
            const responseBody = response === null || response === void 0 ? void 0 : response.data;
            // 401 sometimes implies that a user is unauthenticated and we need to update our tracking accordingly
            // TODO: Revisit when we have error codes (PIE-1108)
            if (response &&
                response.status === 401 &&
                lodash_1.default.get(responseBody, 'error.data.user_is_logged_out')) {
                setUserLoggedOut();
            }
            return {
                response: Object.assign(Object.assign({}, response), { statusCode: response.status }),
                body: responseBody,
            };
        });
    }
    return {
        fetch,
        setKountSessionID,
        setReferringClientID,
        setUserLoggedIn,
        setUserLoggedOut,
    };
}
function createHttpClient(config) {
    if (!config || typeof config !== 'object') {
        throw new Error('config is required');
    }
    return createNewHttpClient(Object.assign({ axios: axios_1.default, nwa: getNWA() }, config));
}
exports.createHttpClient = createHttpClient;
